<template>
  <common-dialog
    ref="dialog"
    title="Add FBA"
    :inputs-map="form"
    :save-cb="saveFba"
    :reset-inputs="reset"
  >
  </common-dialog>
</template>
<script>
// msg
import PagesMessage from '@/core/message/pages'
// others
import cloneDeep from 'lodash/cloneDeep'
// components
import CommonDialog from '@/components/common/CommonDialog.vue'
// models
import { GoodsAddFbaForm } from '@/core/models/goods'
// api
import { modifyGoodsFBA } from '@/api/goods'

export default {
  name: 'AddFbaDialog',
  props: {},
  components: {
    CommonDialog
  },
  methods: {
    saveFba(info, done, error) {
      // todo 需要检查 输入的东西是否正确
      info = Object.fromEntries(info.map(one => [one.key, one.value]))
      modifyGoodsFBA(this.goodsId, info)
        .then(res => {
          this.$message.success('add FBA successfully!')
          PagesMessage.emit(PagesMessage.eventMap.REFRESH_SHIPMENT_BOL)
          done()
        })
        .catch(err => {
          error(err)
        })
    },
    open(goodsId) {
      this.$set(this, 'goodsId', goodsId)
      this.$refs.dialog.open()
    },
    reset() {
      this.form = cloneDeep(GoodsAddFbaForm)
    }
  },
  data() {
    return {
      form: cloneDeep(GoodsAddFbaForm),
      goodsId: ''
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';
</style>
